class FeaturedProducts extends HTMLElement {

  constructor() {
    super();

    this.cart = document.querySelector('cart-drawer');
    this.actions = {
      add: 'ADD',
      update: 'UPDATE'
    }
    this.featuredProductsId = 'featured-products';
  }

  connectedCallback() {
    
    this.bindEvents();

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === this.featuredProductsId) {
        return;
      }
      // If its another section that made the update
      this.events.onCartUpdate(event);
    });
    this.sectionId = this.dataset.id;
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    this.removeEventListener('change', this.events.onQuantityChange);
    this.removeEventListener('click', this.events.onButtonClick);
  }
  
  bindEvents(){
    this.addEventListener('change', this.events.onQuantityChange);
    this.addEventListener('click', this.events.onButtonClick);
  }

  events = {
    onQuantityChange: (e) => {
      e.preventDefault();

      console.log( e.target.name )
      if ( e.target.name !== 'quantity') return;

      // Get current quantity, unit price and selected variant id
      const inputValue = parseInt(e.target.value);
      const cartQuantity = parseInt(e.target.dataset.cartQuantity);
      const quantity = inputValue - cartQuantity;

      console.log ( { inputValue, cartQuantity, quantity })

      const item = e.target.closest('.pl-item');
      const currentVariantId = parseInt(item.dataset.variantId);
      const itemUnitPrice = parseInt(item.dataset.price) || 1;

      if ( cartQuantity > 0) {
        console.log("update")
        this.updateQuantity({
          quantity: inputValue,
          id: currentVariantId,
          action: this.actions.update
        });
      }
      else {
        console.log("add")
        this.updateQuantity({
          quantity: quantity,
          id: currentVariantId,
          action: this.actions.add
        });
      }
    },
    onVariantChange: (e) => {
      const target = e.target;
      const item = target.closest('.pl-item');

      // Get the selected variant price
      const selectedOption = target.selectedOptions[0];
      const selectedVariantPrice = parseInt(selectedOption.dataset.variantPrice);

      item.dataset.variantId = selectedOption.value;

      // Update item price
      item.dataset.variantPrice = selectedVariantPrice;
      
      // Update item unit price
      item.querySelector('[data-item-unit-price]').innerText = Utilities.formatPrice(selectedVariantPrice);
    },
    onButtonClick: (e) => {
      if (e.target instanceof HTMLAnchorElement) return;
      
      if ( e.target.name === 'minus' || e.target.name === 'plus') {
        e.preventDefault();
        const item = e.target.closest('.pl-item');
        const quantityField = item.querySelector('[data-quantity]');
        
        console.log( { item, quantityField })
  
        // when minus and there no value, prevent all
        if ( e.target.name === 'minus' ) {
          if ( quantityField.value === 0 || quantityField.value === '') {
            return;
          }
        }
        
        // update input value and dispatch change event. Event to be handled by onQuantityChange event.)
        (e.target.name === 'minus') ? quantityField.stepDown(): quantityField.stepUp();
  
        quantityField.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    onCartUpdate: (e) => {
      console.log( "cart updated by another section ", e);

      // todo: could merge both request into one
      // Re-render the section
      fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector(this.featuredProductsId);
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });

      fetch(`${window.location.pathname}?section_id=dc-summary`)
      .then((response) => response.text())
      .then((responseText) => {
        document.querySelector('#dc-summary').innerHTML = this.getSectionInnerHTML(responseText,'#dc-summary');
      })
      .catch(e => {
        console.error(e);
      });
    }
  }

  updateQuantity( { quantity = 0, id, action }){

    // show spinner
    // this.toggleLoadingSpinner(id);
    
    // define cart route
    let routeUrl = routes.cart_change_url;

    // define body for CHANGE endpoint by default
    let body = JSON.stringify({
      quantity: quantity,
      id: `${id}`, // needs to be string, otherwise throws error
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    let fetchConfigType;
    if (action === this.actions.add) {
      fetchConfigType = 'javascript';
      routeUrl = routes.cart_add_url;
      body = JSON.stringify({
        items: [
          {
            quantity: parseInt(quantity),
            id: parseInt(id)
          }
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }

    console.log( JSON.parse(body) );

    fetch(`${routeUrl}`, { ...fetchConfig(fetchConfigType), ...{ body } })
    .then( response => response.text())
    .then( state => {
        const parsedState = JSON.parse(state);
        console.log( { parsedState })

        if (parsedState.description || parsedState.errors) {
          /* todo: handle error */
          console.log('error', parsedState)
          return;
        }

        this.renderSections(parsedState);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: this.featuredProductsId, cartData: parsedState });
    })
    .catch((error) => {
        console.error('Error:', error);
    })
    .finally( () => {
      // this.toggleLoadingSpinner(id);
    });
  }

  toggleLoadingSpinner(id) {
    const item = document.getElementById(id);
    const quantityInputField = item.querySelector('[data-quantity]');
    quantityInputField.classList.toggle('loading');
  }

  getSectionsToRender() {
    return [
      {
        id: this.featuredProductsId,
        section: document.getElementById(this.featuredProductsId).dataset.id,
        selector: '.pl-items'
      },
      {
        id: 'dc-summary',
        section: 'dc-summary',
        selector: '.dc-summary'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'CartDrawer',
        selector: '#CartDrawer',
        section: 'cart-drawer'
      }
    ];
  }

  renderSections(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const sectionElement = document.getElementById(section.id);
      if (sectionElement && sectionElement.parentElement && sectionElement.parentElement.classList.contains('drawer')) {
        parsedState.items.length > 0 ? sectionElement.parentElement.classList.remove('is-empty') : sectionElement.parentElement.classList.add('is-empty');

        setTimeout(() => {
          document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
        });
      }
      const elementToReplace = sectionElement && sectionElement.querySelector(section.selector) ? sectionElement.querySelector(section.selector) : sectionElement;
      if (elementToReplace) {
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}


if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts );
}